import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppComponent } from 'src/app/app.component';
import { HeaderBaseComponent } from 'src/app/base/components/header-base.component';
import { OrgInfo } from 'src/app/base/interfaces/org-info';
import { AuthService } from 'src/app/base/services/auth/auth.service';
import { NavService } from 'src/app/base/services/nav/nav.service';
import { WorkflowService } from 'src/app/base/services/workflow/workflow.service';
import { AppidService } from 'src/app/base/services/appid/appid.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent extends HeaderBaseComponent implements OnInit {
    public orginfo: OrgInfo | any;

    selectedOrg: any;

    constructor(
        public auth: AuthService, 
        public nav: NavService, 
        public app: AppComponent, 
        public workflow: WorkflowService, 
        public appIDService: AppidService,
        route: ActivatedRoute
    ) {
        super(auth, nav, app, workflow, appIDService, route);
    }

    ngOnInit(): void {

		// executes the logic of the HeaderBaseComponent (showOrgName, etc)
        super.ngOnInit();  
    }
}